import {BOX_HEIGHTS, BOX_WIDTHS} from '@hconnect/uikit'
import {Box, useMediaQuery, useTheme} from '@mui/material'
import {DowntimeByCategoryChartContainer} from '@widgets/downtime-analytics'
import {OperationHoursFromYesterdayContainer} from '@widgets/running-times'
import {MyTasksSummaryContainer} from '@widgets/tasks'

import {
  ExpertSystemDailyContainer,
  MaterialQualityKpisYesterdayContainer,
  ProcessPlantStatusDailyKpisContainer,
  ProcessPlantStatusKpisContainer
} from '../containers'
import {PlantDashboardDesktopLayout, PlantDashboardMobileLayout} from '../layouts'

type Props = {
  plantId: string
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
  shiftSummaryHref?: string
  myTasksHref?: string
  plantStatusPageHref?: string
  onEquipmentClick?: (equipmentId: string) => void
}

export const ProcessEngineerPlantDashboard = ({
  plantId,
  titleSlot,
  aboveTitleSlot,
  shiftSummaryHref,
  myTasksHref,
  plantStatusPageHref,
  onEquipmentClick
}: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  if (isMobile) {
    return (
      <PlantDashboardMobileLayout
        titleSlot={titleSlot}
        aboveTitleSlot={aboveTitleSlot}
        plantStatusKpisSlot={
          <ProcessPlantStatusDailyKpisContainer
            plantId={plantId}
            plantStatusPageHref={plantStatusPageHref}
          />
        }
        operationHoursSlot={
          <OperationHoursFromYesterdayContainer
            plantId={plantId}
            onEquipmentClick={onEquipmentClick}
            isMobile={true}
          />
        }
        expertSystemUsageSlot={
          <ExpertSystemDailyContainer
            plantId={plantId}
            placeholderWrapperSx={{width: '100%', height: '100%'}}
            shiftSummaryHref={shiftSummaryHref}
          />
        }
        myTasksSlot={
          <MyTasksSummaryContainer
            plantId={plantId}
            cardBoxSx={{width: '100%'}}
            placeholderWrapperSx={{width: '100%', height: '100%'}}
            myTasksHref={myTasksHref}
          />
        }
        downtimeByCategorySlot={
          <DowntimeByCategoryChartContainer
            plantId={plantId}
            cardBoxSx={{
              width: '100%',
              height: BOX_HEIGHTS['M']
            }}
            placeholderWrapperSx={{width: '100%', height: '100%'}}
          />
        }
        qualityParametersSlot={
          <MaterialQualityKpisYesterdayContainer
            plantId={plantId}
            cardBoxSx={{
              width: '100%',
              height: BOX_HEIGHTS['M']
            }}
            placeholderWrapperSx={{height: '100%'}}
          />
        }
      />
    )
  }

  return (
    <PlantDashboardDesktopLayout
      titleSlot={titleSlot}
      aboveTitleSlot={aboveTitleSlot}
      plantStatusKpisSlot={
        <ProcessPlantStatusKpisContainer
          plantId={plantId}
          plantStatusPageHref={plantStatusPageHref}
        />
      }
      operationHoursSlot={
        <OperationHoursFromYesterdayContainer
          plantId={plantId}
          onEquipmentClick={onEquipmentClick}
          cardBoxSx={{width: '100%', height: BOX_HEIGHTS['M']}}
        />
      }
      expertSystemUsageSlot={
        <ExpertSystemDailyContainer
          plantId={plantId}
          cardBoxSx={{width: '100%', height: BOX_HEIGHTS['M']}}
          shiftSummaryHref={shiftSummaryHref}
        />
      }
      myTasksSlot={
        <Box sx={{width: BOX_WIDTHS['S']}}>
          <MyTasksSummaryContainer
            plantId={plantId}
            cardBoxSx={{width: '100%', height: BOX_HEIGHTS['S']}}
            placeholderWrapperSx={{height: '100%'}}
            myTasksHref={myTasksHref}
          />
        </Box>
      }
      downtimeByCategorySlot={
        <DowntimeByCategoryChartContainer
          plantId={plantId}
          cardBoxSx={{
            width: '100%',
            height: BOX_HEIGHTS['M']
          }}
          placeholderWrapperSx={{height: '100%'}}
        />
      }
      qualityParametersSlot={
        <MaterialQualityKpisYesterdayContainer
          plantId={plantId}
          cardBoxSx={{
            width: '100%',
            height: BOX_HEIGHTS['M']
          }}
          placeholderWrapperSx={{height: '100%'}}
        />
      }
    />
  )
}
